// 页面干预逻辑
export function interveneTest(pipelineComponents, pageId, group) {
  if (pageId === '17675052474380033') {
    // 美妆-26年货节会场
    if (group === 'B') {
      // 实验组需要过滤掉白名单中的组件
      const whiteList = [
        'pipeline-imgList-1760532328610',
        'pipeline-tab-1747367798794',
        'pipeline-tabItem-1767684951256',
        'pipeline-tabItem-1767684950989',
        'pipeline-imgList-1732675745105',
        'pipeline-rank-1745496956488',
        'pipeline-rank-1747363276414',
        'pipeline-rank-1747363278410',
        'pipeline-rank-1747363350932',
        'pipeline-rank-1760532598837',
        'pipeline-imgList-1747373949398',
        'pipeline-rank-1747363971378',
        'pipeline-rank-1747364005780',
        'pipeline-rank-1747364007693',
        'pipeline-rank-1747373854192',
        'pipeline-rank-1747373882002',
        'pipeline-rank-1760533925227',
        'pipeline-rank-1760533617865',
        'pipeline-goodsRecommend-1769665913631',
        'navigation-bar',
      ];

      /**
       * 递归过滤组件函数
       * @param {Array} components 组件数组
       * @returns {Array} 过滤后的组件数组
       */
      const filterComponents = (components) => {
        if (!Array.isArray(components)) return components;

        return components.filter(comp => {
          // 1. pipeline-ab 特殊处理：保留且不处理内部组件
          if (comp.name === 'pipeline-ab') {
            return true;
          }

          // 2. 命中白名单的组件保留
          const isWhitelisted = whiteList.includes(comp.id);

          // 3. 处理递归逻辑 (pipeline-tab 和 pipeline-tabItem)
          if (comp.name === 'pipeline-tabItem') {
            // pipeline-tabItem 的 data 是组件数组
            if (Array.isArray(comp.data)) {
              comp.data = filterComponents(comp.data);
            }
          } else if (comp.name === 'pipeline-tab') {
            // pipeline-tab 的 grains 下有 components 数组
            const grains = comp.data.containerConfig.grains;
            if (Array.isArray(grains)) {
              grains.forEach(grain => {
                if (Array.isArray(grain.components)) {
                  // pipeline-tab 的子组件结构是 { component: 'id' }
                  grain.components = grain.components.filter(item => whiteList.includes(item.component));
                }
              });
            }
          }

          return isWhitelisted;
        });
      };

      return filterComponents(pipelineComponents);

    } else {
      // 对照组过滤掉推荐信息流组件
      pipelineComponents = pipelineComponents.filter(comp => comp.id !== 'pipeline-goodsRecommend-1769665913631');
    }
  }

  return pipelineComponents;
}



// WEBPACK FOOTER //
// ./utils/interveneTest.js